// apps/website/src/providers/AppProviders.tsx

import { PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';
import { swrConfig } from '../config/swr';

import {
  SupabaseAuthProvider,
} from '@dopomogai/supabase-client/react';
import type { SupabaseClient } from '@dopomogai/supabase-client';

import {
  GlobalChatProvider,
  ChatbotOverridesProvider as ChatbotOverrideProvider,
} from '@dopomogai/chatbot';

export type AppProvidersProps = PropsWithChildren<{
  supabaseClient: SupabaseClient;
}>;

export function AppProviders({ supabaseClient, children }: AppProvidersProps) {
  return (
    <SWRConfig value={swrConfig}>
      <SupabaseAuthProvider supabaseClient={supabaseClient}>
        <GlobalChatProvider>
          <ChatbotOverrideProvider>{children}</ChatbotOverrideProvider>
        </GlobalChatProvider>
      </SupabaseAuthProvider>
    </SWRConfig>
  );
}

export default AppProviders;
